/* © CNES */
import { useQuery } from '@tanstack/react-query';
import { NavigateFunction } from 'react-router-dom';
import { DATASET } from '../../components/shared/Constants';
import { QueryModel, searchItems } from './Items';

const QUERY_KEY = 'Items';

/**
 * UseQuery synthax to call getItems from regards.
 * @param queryParams query Params.
 * @param navigate function to trigger navigation when error is returned.
 * @returns UseQueryResult.
 */
export const useGetItems = (
  queryParams: QueryModel,
  navigate: NavigateFunction,
  setError400: Function
) => {
  return useQuery({
    queryKey: [QUERY_KEY, queryParams, navigate, setError400],
    queryFn: searchItems,
    refetchOnWindowFocus: false,
    enabled: !!queryParams?.params?.[DATASET],
  });
};
